module.exports = __webpack_public_path__ + "img/icon-view.f7d4470e.svg";